import React from 'react';
import PropTypes from 'prop-types';

import PickBarber from './PickBarber';
import GifCardAmount from '../GiftCardAmount';
import BarberSelectionMessage from './BarberSelectionMessage';

const GiftCard = ({
  barbers,
  gcBarber,
  onSelectedBarberChange,
  gcAmount,
  onGcAmountChange,
  isCommissionShop,
  areGcSalesDisabledForBarber,
}) => (
  <div className="u-mb- medium-and-up-mb+">
    {!areGcSalesDisabledForBarber
      && (<div className="c-heading c-heading--huge u-mb u-pt-- u-show-for-large-and-up">Pick a Professional</div>)}
    {!areGcSalesDisabledForBarber
      && (<div
        className="c-heading c-heading--huge u-mb- u-text-center u-hide-for-large-and-up"
      >Pick a Professional</div>)}
    <div className="layout">
      {
        (isCommissionShop && !areGcSalesDisabledForBarber) && (
          <div className="layout__item u-1/1">
            <BarberSelectionMessage />
          </div>
        )
      }
      <div className="layout__item u-1/1 u-1/2-medium-and-up">
        {!areGcSalesDisabledForBarber && <PickBarber
          barbers={barbers}
          selectedBarber={gcBarber}
          onSelectedBarberChange={onSelectedBarberChange}
        />}
      </div>
      <div className="layout__item u-1/1 u-1/2-medium-and-up">
        <GifCardAmount
          gcAmount={gcAmount}
          onGcAmountChange={onGcAmountChange}
        />
      </div>
    </div>
  </div>
);

GiftCard.propTypes = {
  gcBarber: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  barbers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  })).isRequired,
  onSelectedBarberChange: PropTypes.func.isRequired,
  gcAmount: PropTypes.number.isRequired,
  onGcAmountChange: PropTypes.func.isRequired,
  isCommissionShop: PropTypes.bool,
  areGcSalesDisabledForBarber: PropTypes.bool.isRequired,
};

GiftCard.defaultProps = {
  isCommissionShop: false,
};

GiftCard.defaultProps = {
  gcBarber: null,
};

export default GiftCard;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCard/GiftCard.jsx